import { getCalcInputState } from '../../../../../utils/selectors'
import { jobSettingsSlice } from './slice'

export const getJobSettingsState = (state) => getCalcInputState(state)[jobSettingsSlice.name]
export const getJobID = state => getJobSettingsState(state).jobID